module.exports = __webpack_public_path__ + "img/jskffw.0bc6d3ba.png";